import { observer } from 'mobx-react';
import { Grid, Box, Paper, Typography, Link } from "@mui/material";
import Header from "../shared/header";
import Footer from "../shared/footer";
import styles from './wallet.module.scss'

const TermsOfUse = observer(() => {

    return (
        <>
            <Header></Header>

            <Grid className='content' container>
                <Box className={styles.wrapper}>
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="h6" color='#242333' fontWeight={700}>Terms of Use</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: 'center', mt: 2 }}>


                        <Paper variant="round" sx={{ p: 4, width: '100%' }}>
                            Welcome to our Contacts Management Web App ("n’Sync App"). Before you proceed, please read the following Terms of Use carefully.
                            By accessing or using our App, you agree to be bound by these terms and conditions.
                            If you do not agree with any part of these Terms, you must refrain from using the App.


                            <h4>Acceptance of Terms </h4>
                            These Terms of Use constitute a legal agreement between you ("User" or "you") and n’Sync App, the owner and operator of the Contacts Management Web App. By accessing or using the App, you acknowledge that you have read, understood, and agree to be bound by these Terms.

                            Before you continue using our website, we advise you to read our <Link href='/privacy-policy'>privacy policy</Link> regarding our user data collection. It will help you better understand our practices.

                            <h4>Payment and Refunds </h4>

                            <h5>2.1 Payment</h5>
                            The App offers premium features that require payment. By making a payment, you acknowledge and agree to the fees associated with the chosen premium features. Payment can be made through various payment methods as indicated on the App.

                            <h5>2.2 No Refunds</h5>
                            All payments made through the App are non-refundable. Once a payment is made, it is considered final and non-reversible. Regardless of whether you choose to use the premium features, we do not offer refunds for any payments made.

                            <h4>Account and User Data</h4>

                            <h5>3.1 Account Creation</h5>
                            To access and utilize the App's features, you may be required to create an account. You are responsible for providing accurate and up-to-date information during the account registration process.

                            <h5>3.2 User Data</h5>
                            By using the App, you agree that any information or data you provide, including contacts and personal details, will be collected and stored in accordance with our Privacy Policy. We are not responsible for any loss of data or damage to user data resulting from the use of the App.

                            <h5>3.3 Age restriction</h5>
                            You must be at least 18 (eighteen) years of age before you can use this website. By using this
                            website, you warrant that you are at least 18 years of age and you may legally adhere to this
                            Agreement. n'Sync app assumes no responsibility for liabilities related to age misrepresentation.

                            <h4>Prohibited Activities</h4>


                            You agree not to engage in any of the following activities while using the App:
                            Violating any applicable laws or regulations.
                            Infringing upon the intellectual property rights of others.
                            Using the App for any unlawful, harmful, or fraudulent purpose.
                            Attempting to gain unauthorized access to the App or its related systems.
                            Interfering with the proper functioning of the App or its services.


                            <h4>Intellectual Property</h4>
                            All intellectual property rights in the App, including but not limited to software, design, logos, trademarks, and content, are owned or licensed by n'Sync app. You may not reproduce, distribute, modify, or create derivative works of any part of the App without our explicit written consent.


                            <h4>Termination</h4>
                            We reserve the right to terminate or suspend your access to the App, with or without cause, at any time and without prior notice. Upon termination, your account and all related information may be deleted or made inaccessible.


                            <h4>Disclaimer of Warranties</h4>
                            The App is provided "as is" and "as available" without warranties of any kind, whether express or implied. We do not warrant that the App will be error-free, secure, or uninterrupted.


                            <h4>Limitation of Liability</h4>
                            In no event shall n'Sync app be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with the use of the App or these Terms of Use.


                            <h4>Changes to the Terms</h4>
                            We may update or modify these Terms of Use from time to time. Any changes will be effective immediately upon posting on the App. Your continued use of the App after the posting of changes constitutes your acceptance of the modified Terms.


                            <h4>Governing Law and Jurisdiction</h4>
                            These Terms of Use shall be governed by and construed in accordance with the laws of Jordan. Any dispute arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts located in Amman, Jordan.

                            <br />
                            <br />

                            By using our Contacts Management Web App, you agree to comply with these Terms of Use. If you do not agree with any part of these Terms, please refrain from using the App.

                            <br />
                            <br />

                            If you have any questions or concerns regarding these Terms of Use, please contact us at info@nsync.com.

                            <br />
                            <br />

                            Last updated: 7/25/2023



                        </Paper>
                    </Box>
                </Box>
            </Grid>
            <Footer></Footer>
        </>
    );
});

export default TermsOfUse;